<template>
	<div>
		<div class="text-right">
			<vx-tooltip :text="'Duplicate'" position="bottom" class="inline-flex">
			   <feather-icon icon="CopyIcon" :svgClasses="`h-5 w-5 cursor-pointer`" @click="duplicatePromoRequest()"/>
			</vx-tooltip>
		</div>	
	</div>
	
</template>

<script>
	
	 export default {
	 	name: 'CellRendererSuggestionActions',	 
		data() {
			return {  				 
			}
		},
        computed: {           
		},
		methods: {
			duplicatePromoRequest(){
				// console.log(this.params.node.parent);
				//console.log(this.params.data);
				var rowData = this.params;
				this.$root.$emit('duplicatePromoRequest', rowData);
			},			
		 },
	}
</script>
<style lang="scss">
    .disabled{
		pointer-events: none;
        opacity: 0.4;
	}
</style>